var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 7.1 9.4",
    style: {
      enableBackground: "new 0 0 7.1 9.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.9,9.4c-0.2,0-0.5-0.1-0.6-0.3C0.1,8.9,0,8.7,0,8.5V4c0-0.2,0.1-0.5,0.3-0.6c0.2-0.2,0.4-0.3,0.6-0.3h0.4V2.2 c0-0.6,0.2-1.1,0.7-1.6C2.4,0.2,2.9,0,3.6,0s1.1,0.2,1.6,0.6c0.4,0.4,0.6,1,0.6,1.6v0.9h0.4c0.2,0,0.5,0.1,0.6,0.3 C7,3.6,7.1,3.8,7.1,4v4.4c0,0.2-0.1,0.5-0.3,0.6C6.7,9.3,6.5,9.4,6.2,9.4H0.9z M3.6,7.1C3.8,7.1,4,7,4.2,6.9 c0.2-0.2,0.3-0.4,0.3-0.6c0-0.2-0.1-0.5-0.3-0.6C4,5.4,3.8,5.4,3.6,5.4S3.1,5.4,2.9,5.6C2.8,5.8,2.7,6,2.7,6.2 c0,0.2,0.1,0.5,0.3,0.6C3.1,7,3.3,7.1,3.6,7.1z M2.2,3.1h2.7V2.2c0-0.4-0.1-0.7-0.4-0.9C4.2,1,3.9,0.9,3.6,0.9S2.9,1,2.6,1.3 C2.4,1.6,2.2,1.9,2.2,2.2V3.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockContent);
export default __webpack_public_path__ + "static/media/lock-content.3d79a826167580fe9e83865a0a14091a.svg";
export { ForwardRef as ReactComponent };